{
    "CustomNameLabel": "Naam:",
    "CustomWidthLabel": "Breedte (0 - 100):",
    "CustomSettings_SectionHeader": "Aangepaste instellingen",
    "NAME": "CustomSettings"
}